// Состояние "моя подписка" (ТЗ раздел 3.3, экран 3).
import { create } from "zustand";

import type { Subscription } from "../api/client";

interface SubscriptionState {
  subscription: Subscription | null;
  loading: boolean;
  error: string | null;
  setSubscription: (subscription: Subscription | null) => void;
  setLoading: (v: boolean) => void;
  setError: (error: string | null) => void;
}

export const useSubscriptionStore = create<SubscriptionState>((set) => ({
  subscription: null,
  loading: false,
  error: null,
  setSubscription: (subscription) => set({ subscription, loading: false, error: null }),
  setLoading: (v) => set({ loading: v }),
  setError: (error) => set({ error, loading: false }),
}));
